<template>
    <div class="has-text-centered">
        <img :src="require('@/assets' + fileName)" alt="dxbanksolutionslogo">
        <p class="is-size-5" :style="{color: 'rgb(255, 255, 255)'}">
            {{ title }}
        </p>
    </div>
</template>
<script>
	export default {
		name: "OurDXBankSolutionsLogoComponent",
		props: {
			title: String,
			fileName: String,
		},
	};
</script>